module.exports = __webpack_public_path__ + "static/media/lessons_white.86ed1e0e.svg";